export const RULES_ENGINE_ERROR_CODES = {
  UNAUTHORIZED: 'RULES_ENGINE_UNAUTHORIZED',
  FORBIDDEN: 'RULES_ENGINE_FORBIDDEN',
  RATE_LIMITED: 'RULES_ENGINE_RATE_LIMITED',
  REQUEST_FAILED: 'RULES_ENGINE_REQUEST_FAILED',
}

export const RULES_ENGINE_STATUS_MESSAGES = {
  401: 'Sessao tecnica expirada ou revogada. Reautenticando...',
  403: 'Sem permissao para este recurso.',
  429: 'Limite temporario excedido. Tente novamente em instantes.',
}

const resolveErrorCode = (status) => {
  if (status === 401)
    return RULES_ENGINE_ERROR_CODES.UNAUTHORIZED

  if (status === 403)
    return RULES_ENGINE_ERROR_CODES.FORBIDDEN

  if (status === 429)
    return RULES_ENGINE_ERROR_CODES.RATE_LIMITED

  return RULES_ENGINE_ERROR_CODES.REQUEST_FAILED
}

const BACKEND_ERROR_TRANSLATIONS = {
  'cannot disable obrigatoria_regulatoria rule': 'Regra regulatória obrigatória não pode ser desativada.',
  'plan rule does not allow client to disable this rule': 'O plano não permite que o cliente desative esta regra.',
  'client_policy override_mode is none; override not permitted': 'A política do cliente não permite overrides.',
  'an active default policy already exists for this organization and transaction type': 'Já existe uma política padrão ativa para esta organização e este tipo de transação.',
}

const translateBackendMessage = (message) => {
  if (!message) {
    return message
  }

  const lower = message.toLowerCase()

  for (const [key, translation] of Object.entries(BACKEND_ERROR_TRANSLATIONS)) {
    if (lower.includes(key.toLowerCase())) {
      return translation
    }
  }

  return message
}

const extractBackendMessages = (cause) => {
  const data = cause?.response?.data

  if (!data) {
    return null
  }

  if (Array.isArray(data.errors) && data.errors.length) {
    return data.errors.map(translateBackendMessage).join(' ')
  }

  if (typeof data.error === 'string' && data.error.length) {
    return translateBackendMessage(data.error)
  }

  if (data.error && typeof data.error === 'object' && typeof data.error.message === 'string' && data.error.message.length) {
    return translateBackendMessage(data.error.message)
  }

  if (typeof data.message === 'string' && data.message.length) {
    return translateBackendMessage(data.message)
  }

  return null
}

export const createRulesEngineError = ({
  status,
  message,
  cause,
  retryable = false,
}) => {
  const backendMessages = extractBackendMessages(cause)
  const error = new Error(message || RULES_ENGINE_STATUS_MESSAGES[status] || 'Falha ao consumir rules-engine.')

  error.name = 'RulesEngineError'
  error.status = status
  error.code = resolveErrorCode(status)
  error.retryable = retryable
  error.cause = cause
  error.backendMessages = backendMessages

  return error
}

export const toRulesEngineError = (err, options = {}) => {
  const status = err?.response?.status || options.status

  return createRulesEngineError({
    status,
    message: options.message || RULES_ENGINE_STATUS_MESSAGES[status],
    cause: err,
    retryable: Boolean(options.retryable),
  })
}

export const getRulesEngineUiMessage = (err, fallbackMessage = 'Nao foi possivel carregar os dados no momento.') => {
  const status = err?.status || err?.response?.status

  if (RULES_ENGINE_STATUS_MESSAGES[status]) {
    return RULES_ENGINE_STATUS_MESSAGES[status]
  }

  if (err?.backendMessages) {
    return err.backendMessages
  }

  return err?.message || fallbackMessage
}
